import { dbInstallTfFactory } from "@p0security/integrations-db";

export const installSql = `
CREATE USER p0_iam_manager IDENTIFIED WITH AWSAuthenticationPlugin AS 'RDS';
GRANT CREATE USER, CREATE ROLE ON *.* TO p0_iam_manager;
GRANT ROLE_ADMIN ON *.* TO p0_iam_manager;
GRANT ALL PRIVILEGES ON \`%\`.* TO p0_iam_manager WITH GRANT OPTION;
`.trim();

export const installTf = dbInstallTfFactory("mysql", {
  version: "0.3.0",
  arguments: ({ rdsArnRef }) => `rds_arn = ${rdsArnRef}`,
});
